module.exports = __webpack_public_path__ + "img/files.ce8187c5.svg";